export default function() {
    if(document.querySelector('.tabs-homepage') !== null) {
        const element = document.querySelector('.tabs-homepage');
        const observer = new IntersectionObserver(entries => {
            element.classList.toggle('isInView', entries[0].isIntersecting);
        });

        observer.observe(element);
    }
}